import { create } from "zustand";
import { collection, onSnapshot, query, where, Unsubscribe } from 'firebase/firestore';
import { MASTER_CATALOGUEPATH } from '../constants/paths';

interface MasterTracksState {
  tracks: { [key: string]: any };
  isInitialized: boolean;
  unsubscribe: Unsubscribe | null;

  setTracks: (tracks: { [key: string]: any }) => void;
  queryTracks: (filter?: any) => any[];
  initTracks: (firebase: any) => void;
  clearTracks: () => void;
}

export const useMasterTracksStore = create<MasterTracksState>((set, get) => ({
  tracks: {},
  isInitialized: false,
  unsubscribe: null,

  setTracks: (tracks: { [key: string]: any }) => set({ tracks }),

  queryTracks: () => Object.values(get().tracks),

  /**
   * Initialize tracks listener for the master catalogue (all tracks from all orgs)
   */
  initTracks: (firebase: any) => {
    const state = get();

    // If already initialized, skip
    if (state.isInitialized) {
      return;
    }

    // Clean up any existing listener
    if (state.unsubscribe) {
      state.unsubscribe();
    }

    // Clear existing tracks
    set({ tracks: {}, isInitialized: false });

    if (!firebase) {
      set({ isInitialized: true });
      return;
    }

    // Query the master catalogue collection (all public tracks from all orgs)
    const masterRef = collection(firebase.db, MASTER_CATALOGUEPATH);
    const masterQuery = query(
      masterRef,
      where('isPublic', '==', true)
    );

    const unsubscribe = onSnapshot(masterQuery, (snapshot: any) => {
      const tracks: { [key: string]: any } = {};
      snapshot.forEach((doc: any) => {
        tracks[doc.id] = { ...doc.data(), id: doc.id };
      });
      set({ tracks });
    }, (error: any) => {
      console.error('Error listening to master catalogue:', error);
    });

    set({
      isInitialized: true,
      unsubscribe,
    });
  },

  /**
   * Clear tracks and unsubscribe (for logout)
   */
  clearTracks: () => {
    const state = get();
    if (state.unsubscribe) {
      state.unsubscribe();
    }
    set({
      tracks: {},
      isInitialized: false,
      unsubscribe: null,
    });
  },
}));
